'use client'

import { useEffect } from 'react'
import { log404Error } from 'app/actions/notFoundLogging'

/**
 * Client component that logs 404 errors
 * This is separate from the page component to avoid server/client component conflicts
 */
export default function NotFoundLogger() {
    useEffect(() => {
        // Log the 404 error with the current URL
        const currentUrl = window.location.href
        log404Error(currentUrl)
    }, [])

    // This component doesn't render anything
    return null
}
